import PropTypes from 'prop-types'
import React from 'react'
import './Skeleton.module.scss'

const propTypes = {
  count: PropTypes.number,
}

function Skeleton(props) {
  const { count = 1 } = props ?? {}

  const result = []
  for (let i = 0; i < count; i += 1) {
    result.push(
      <span key={`${i}-span`} className="Uic-Skeleton-skeleton">
        &zwnj;
      </span>,
    )
    if (i > 0) {
      result.push(<br key={`${i}-br`} />)
    }
  }

  return <span>{result}</span>
}

Skeleton.propTypes = propTypes

export default Skeleton
